import styled from "styled-components"

const Box = styled.div`

    line-height: 1.375;
    padding-left: 2.5rem;
    padding-right: 2.5rem;
    margin-bottom: 2.5rem;

    @media (min-width: 1024px)
    {width: 33.333333%;}


    @media (min-width: 1024px)
   {
    margin-bottom: 0;
   }

`

const Title = styled.h3`

    --tw-text-opacity: 1;
    color: rgba(51,51,51,var(--tw-text-opacity));
    letter-spacing: -0.025em;
    font-weight: 700;
    font-size: 1.875rem;
    line-height: 2.25rem;
    margin-bottom: 1.25rem;

    @media (min-width: 768px)
    {
    font-size: 2.25rem;
    line-height: 2.5rem;
    }

`

const Info = styled.p`

    letter-spacing: -0.025em;
    font-size: 1.125rem;
    line-height: 1.75rem;

`
export const InfoCard = ({title, info}) => {

    return (
        <Box>
            <Title>
                {title}
            </Title>
            <Info>
                {info}
            </Info>
        </Box>
    )
}
